import { configureStore } from "@reduxjs/toolkit";
import {
  alert,
  app,
  auth,
  brand,
  contact,
  homeCarousel,
  order,
  products,
  promoCodes,
  promoCodesUsage,
  userReducer,
  categoriesReducer,
} from "./reducers";

const store = configureStore({
  reducer: {
    auth,
    app,
    promoCodes,
    products,
    brand,
    order,
    contact,
    promoCodesUsage,
    userReducer,
    homeCarousel,
    alert,
    categories: categoriesReducer,
  },

  devTools: process.env.NODE_ENV === "production" ? false : true,
});

export default store;
